import Page from "webPage/Page";
import Gallery from "webPage/Gallery";

Page.register("page-template-homepage", () => {
    let hero_slides = new Gallery($('.js-hero-slides'), {
        itemClass: "hero-slide",
        itemsClass: "js-hero-slides-wrap",
        itemActiveModifier: "active",
        pipsClass: "js-pips",
        pipClass: "pips__icon",
        animationDuration: 500,
    });

    let gallery_interval = setInterval(() => {
        hero_slides.navigate(Gallery.FORWARDS);
    }, 3000);

    hero_slides.on("transitionStart", () => {
        clearInterval(gallery_interval);
    })

    hero_slides.on("transitionEnd", () => {
        gallery_interval = setInterval(() => {
            hero_slides.navigate(Gallery.FORWARDS);
        }, 3000);
    });
});
